module.exports = __webpack_public_path__ + "static/media/infi-1.775cfb03.png";